import styles from './page-description.module.css';

export function PageDescription() {
  return (
    <div className={styles.container}>
      <h1 className={styles.heading}>PR TIMESに企業登録申請</h1>

      <div className={styles.detail}>
        <p>
          <span>
            PR
            TIMESの利用を希望される方は、以下のフォームより企業登録申請を行ってください。当社所定の基準に従った登録審査を実施した後に、アカウント開設となります。審査には約1営業日お時間をいただいております。
          </span>
          <span>
            企業登録申請方法については
            <a
              href='/magazine/application'
              target='_blank'
              className={styles.link}
            >
              ヘルプページ
            </a>
            、サービスの詳細については各サービスページ、
            <a href='/price' target='_blank' className={styles.link}>
              料金ページ
            </a>
            をご確認ください。
          </span>
        </p>

        <p className={styles.supplement}>
          <span>
            ※プレスリリース配信サービス「
            <a href='/' target='_blank' className={styles.link}>
              PR TIMES
            </a>
            」、ストーリー配信サービス「
            <a href='/story' target='_blank' className={styles.link}>
              PR TIMES STORY
            </a>
            」、「
            <a
              href='/webclipping/service/'
              target='_blank'
              className={styles.link}
            >
              Webクリッピング機能
            </a>
            」がご利用いただけます。
          </span>
          <span>
            ※企業登録申請は料金が発生いたしません。アカウント開設後、サービスをご利用された場合（プレスリリース配信など）に料金が発生いたします。
          </span>
          <span>
            ※ご入力頂いた企業情報はPR&nbsp;TIMES上の企業ページやプレスリリースページで公開されます。ただし個人事業主の場合は初期状態で本社所在地・代表電話番号が非公開となります。
          </span>
        </p>
      </div>
    </div>
  );
}
